import React from 'react';
import ReactDOM from 'react-dom/client';
//Page
import { ProSidebarProvider } from 'react-pro-sidebar';
import App from "./App";

// import reportWebVitals from './reportWebVitals';

//local store
// import { createStore } from 'redux';
import {store} from './reducers/index';
// import reducer from './reducers';
import { Provider } from 'react-redux';

//Css
import './css/index.css';

import 'lightbox2/dist/js/lightbox-plus-jquery.js';
import 'lightbox2/dist/css/lightbox.min.css';

if (process.env.NODE_ENV === 'production') {
  //console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ProSidebarProvider>
      <span></span>
      <App/>
    </ProSidebarProvider>
  </Provider>
);



